import Conversion from './conversion'
import hexdigest from 'lib/hexdigest'
import loadRemoteScript from 'lib/load-remote-script'

export default class Criteo extends Conversion {
  constructor ({ ...args } = {}) {
    super({ ...args })
    this.account = 110576
    // this needs to be clarified
    this.pushWithoutInstall = false
    this.pushWithoutConsent = false
    this.setupMaybe()
  }

  async install () {
    this.criteo_q
      = await loadRemoteScript({
        url: `https://dynamic.criteo.com/js/ld/ld.js?a=${this.account}`,
        globalName: 'criteo_q',
      })
    return this.criteo_q
  }

  async handleConsentGiven () {
    this.pushPageVisit()
  }

  pushPageVisit () {
    this.push(this.commonData)
  }

  get commonData () {
    return [
      { event: 'setAccount', account: this.account },
      { event: 'setSiteType', type: this.deviceType },
    ]
  }

  deliver (item) {
    this.q.push(item)
  }

  get q () {
    return this.criteo_q
  }

  static formatItem (item) {
    switch (item.event) {
      case 'purchase':
        return this.formatPurchase(item)
      default:
        return item
    }
  }

  static formatPurchase (item) {
    return [
      {
        event: 'trackTransaction',
        id: item.transaction_id,
        item: item.items.map(item => this.formatTransactionItem(item)),
      },
      this.hashedEmailEvent(item.email)]
  }

  static formatTransactionItem (item) {
    return {
      id: item.item_id,
      price: item.price - item.discount,
      quantity: item.quantity,
    }
  }

  static hashedEmailEvent (email) {
    return { event: 'setEmail', email: hexdigest('SHA-256', email), hash_method: 'SHA-256' }
  }

  static eventNamesMap = {
    page_view: 'viewPage',
    view_home_page: 'viewHome',
  }

  get deviceType () {
    if (this._deviceType !== undefined) return this._deviceType

    this._deviceType = /iPad/.test(navigator.userAgent)
      ? 't'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? 'm' : 'd'
    return this._deviceType
  }
}
